export const LOCAL_STORAGE = {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    ID_TOKEN: 'ID_TOKEN',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER: 'USER',
    ROLE: 'ROLE',
    USER_DATA: 'USER_DATA',
    USER_CURRENCY: 'USER_CURRENCY',
    DEALER_NAME: 'DEALER_NAME',
    SHOW_AVAILABLE: 'SHOW_AVAILABLE',
    SHOW_ITEMS: 'SHOW_ITEMS',
    USER_SHOW_ITEMS: 'USER_SHOW_ITEMS',
    IS_AVAILABLE: 'IS_AVAILABLE',
    USER_ID: 'USER_ID',
    PREFERRED: 'IS_PREFERRED_WAREHOUSE',
    SORT_KEY: 'SORT_KEY'

};

export const STATUS_CODE = {
    UNAUTHORIZED_STATUS_CODE: 401,
    FORBIDDEN_STATUS_CODE: 403,
};

export const EXCEPTION = {
    SYSTEM_EXCEPTION: 'SystemException',
    BUSINESS_EXCEPTION: 'BusinessException'
}





